import Header from '../../../../components/Header';
import Footer from '../../../../components/Footer/Footer';
import { MMANavbar } from '../../../../components/Tools/Navbar/Navbar';
import { Breadcrumb, Tab, Tabs } from 'react-bootstrap';
import { FaHome } from 'react-icons/fa';

import 'bootstrap/dist/css/bootstrap.min.css';

// 5.6 LOCKOUT BEFORE PERFORMING MAINTENANCE TASKS
// 5.6.1 Maintaining Safety Features

const SIMaintenanceLockout = () => {
	return (
		<>
			<Header plant="montgomery" />
			<main>
				<wrapper class="section-wrapper">
					<MMANavbar />
					<container class="section-container">
						<Breadcrumb>
							<Breadcrumb.Item href="/smart-inspect/montgomery/overview">
								<FaHome size={20} />
							</Breadcrumb.Item>
							<Breadcrumb.Item active>Maintenance</Breadcrumb.Item>
							<Breadcrumb.Item active>Maintenance Lockout</Breadcrumb.Item>
						</Breadcrumb>
						<content class="section-content">
							<Tabs defaultActiveKey="Maintenance Lockout" className="mb-3">
								<Tab eventKey="Maintenance Lockout" title="Maintenance Lockout">
									<h2>LOCKOUT BEFORE PERFORMING MAINTENANCE TASKS</h2>
									<p>Safety Lockouts are a set of safety standards used to describe all potential hazards and energy sources associated with a machine. These hazards include all electrical energy (i.e., motors, switches) as well as any stored energy (i.e. pneumatic pressure, hydraulic pressure, water pressure, mechanical gravity devices). With Lockout standards, operating and maintenance work on the machine and associated mechanical devices can be performed in a safe manner. The Lockout placards are posted on the equipment in a location that is easily accessible to the operating and maintenance personnel, typically on the main electrical panel. A MPS placard is located at every entrance gate.</p>

									<p>Each safeguarded area has its own independent MPS System with a gate box typically located at entrance gates. A risk assessment is done to determine what tasks can be done under MPS Control. Typically, these are routine maintenance type tasks (e.g., change weld caps, adjust parts, replace/adjust sensors, cleaning, etc.) MPS can only be used for tasks listed on an MPS Placard. For tasks not listed on the MPS placard, always use the lockout placard procedures. If there is no MPS placard present, follow lockout placard procedures. When in doubt, lock it out! Lock must be applied to the gate box locking arm for all MPS tasks.</p>

									<p>The Lockout consists of a Graphics Placard that identifies the type and location of each energy source shown on a plan view of the machine and a Procedure Placard describing how to Lockout and verify the Lockout of each energy source. The Lockout and hazard locations on the graphics placard designated the type of energy source with symbols (i.e., E1, E2, E3, P1, W1, W2, G1 and G2). These symbols correspond to tags posted on the machine near the energy source for easy identification of the Lockout point.</p>

									<p>
										<b>ALWAYS</b> follow the instructions on the sign(s) POSTED ON THE EQUIPMENT for proper Lockout. Before performing any maintenance or repair work:
									</p>

									<ul>
										<li>Consult the placard lockout procedures posted on the equipment before performing any maintenance or repair task. No person should begin maintenance repairs until the proper LOCKOUT procedures are completed. The employee should contact his/her immediate supervisor if there are any questions about the identification of potential energy sources.</li>
										<li>When service or maintenance is to be conducted, equipment must be put in the OFF position via energy isolating devices such as electrical disconnects and valves.</li>
										<li>Before shutting down the equipment to Lockout energy sources, the employee performing the procedure, or the supervisor shall inform affected employees of the intention to shut down the equipment.</li>

										<p>If the machine or equipment is operating, it must be shut down using normal shut down procedures.</p>
									</ul>
								</Tab>

								<Tab eventKey="Maintaining Safety Features" title="Maintaining Safety Features">
									<h2>Maintaining Safety Features</h2>
									<p>Failure to properly operate and maintain the cells safety features will increase risk of injury to the operator and all other persons adjacent to the machine.</p>
									<p>Access to the cell components is limited due to fencing, guarding, etc. As such, special precautions must be taken when gaining entry into the cell to access the equipment to perform maintenance or repairs.</p>
									<ul>
										<li>Remove guarding only when absolutely necessary.</li>
										<li>Replace all guarding completely before returning machine to production.</li>
										<li>Repair or replace any defects in the safety device before restarting machine.</li>
										<li>Never defeat safety devices and guards.</li>
									</ul>
									<div class="warning">
										<p>
											Follow <b>LOTO</b> placards before removing guarding to work on the system.
										</p>
										<p>Never operate this machine unless all guarding is in place and undamaged.</p>
										<p>Ensure that guarding is handled properly. When servicing machine, ensure guarding is placed in a safe place, away from moving parts.</p>
										<p>Disregarding these safety precautions can result in machine damage, injury or death</p>
									</div>
								</Tab>
							</Tabs>
						</content>
					</container>
				</wrapper>
			</main>
			<Footer />
		</>
	);
};

export default SIMaintenanceLockout;
